<template>
  <d2-container>
    <!-- <template slot="header">
      <el-select
        @keyup.enter.native="getSearch"
        v-model="type"
        clearable
        placeholder="请选择类型"
        size="small"
        style="margin-top:5px;margin-right: 20px;"
      >
        <el-option
          v-for="item in typeList"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        ></el-option>
      </el-select>
      <el-button @click="getSearch" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    </template>-->
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      style="margin-bottom:10px"
      v-permission:function="['memberAttributes:btn_add']"
      @click="getAdd"
    >添加</el-button>
    <el-tabs v-model="type" @tab-click="handleClick">
      <el-tab-pane label="亲密关系" name="1"></el-tab-pane>
      <el-tab-pane label="气质特征" name="2"></el-tab-pane>
      <el-tab-pane label="基础" name="3"></el-tab-pane>
      <el-tab-pane label="能力" name="4"></el-tab-pane>
      <el-tab-pane label="影响力" name="5"></el-tab-pane>
    </el-tabs>
    <el-table
      size="small"
      :key="tableKey"
      :data="list"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{scope.row.id}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="颜色">
        <template slot-scope="scope">
          <el-color-picker v-model="scope.row.color" disabled></el-color-picker>
        </template>
      </el-table-column>
      <el-table-column align="center" label="图标">
        <template slot-scope="scope">
          <img :src="scope.row.icon" style="width: 80px; height: 80px; object-fit: cover" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称">
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="副标题">
        <template slot-scope="scope">
          <span>{{scope.row.subtitle}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="类型" width="130">
        <template slot-scope="scope">
          <span>{{scope.row.type == 1 ? '亲密关系' : scope.row.type == 2 ? '气质特征' : scope.row.type == 3 ? '基础' : scope.row.type == 4 ? '能力': '影响力'}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{scope.row.createTime}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="280" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="small"
            v-permission:function="['memberAttributes:btn_edit']"
            type="success"
            @click="getEdit(scope.row)"
          >编辑</el-button>
          <el-button
            size="small"
            type="danger"
            v-permission:function="['memberAttributes:btn_del']"
            @click="getDel(scope.row.id)"
            :disabled="scope.row.state == 1 ?true:false"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </template>
  </d2-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { attList, delAtt } from '@/api/demo/attributes/index'
export default {
  name: 'memberAttributes',
  data () {
    return {
      memberAttributes_btn_add: false,
      memberAttributes_btn_edit: false,
      memberAttributes_btn_del: false,

      tableKey: 0,
      list: [],
      total: null,
      listLoading: true, // 加载圈圈
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      type: '1',
      typeList: [
        {
          key: 1,
          value: '亲密关系'
        },
        {
          key: 2,
          value: '气质特征'
        },
        {
          key: 3,
          value: '基础'
        },
        {
          key: 4,
          value: '能力'
        },
        {
          key: 5,
          value: '影响力'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['elements'])
  },
  created () {
    let that = this
    that.getList()
  },
  watch: {
    $route (to, from) {
      this.getList()
    }
  },
  methods: {
    // 添加大赛
    getAdd () {
      this.$router.push({
        path: '/demo/attributes/addAttributes'
      })
    },
    // 查询列表
    getList () {
      let that = this
      //   if (val) {
      //     that.listQuery.currentPage = val;
      //   } else {
      //     that.listQuery.currentPage = 1;
      //   }
      attList(that.listQuery, parseInt(that.type)).then(res => {
        that.listLoading = true
        that.list = res.records
        that.total = parseInt(res.total)
        that.listLoading = false
        console.log('that.list', that.list)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getList()
    },
    // 搜索
    handleClick (tab) {
      let that = this
      that.type = tab.name
      that.getList()
    },
    // 编辑
    getEdit (row) {
      this.$router.push({
        path: '/demo/attributes/addAttributes',
        query: {
          id: row.id
        }
      })
    },
    // 删除
    getDel (id) {
      this.$confirm('此操作将删除该属性, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delAtt(id).then(res => {
            this.getList()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style scoped>
.greed {
  color: green;
}
.red {
  color: red;
}
.blue {
  color: blue;
}
::v-deep .el-tabs__item {
  width: 150px;
  text-align: center;
}
</style>
